import {Formik, Form, FormikHelpers} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addNFCtoConductor, getConductorNFC} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {BusAttendeeBase} from './type'
import {NFCCreate} from '../../../types/type'
import {useQuery} from 'react-query'
import TopBarProgress from 'react-topbar-progress-indicator'
import {RunnerBall} from '../../../components/FormLoader'

function NFC({
  initialValues: conductorDetails,
  onAfterSubmit,
}: {
  initialValues?: BusAttendeeBase
  onAfterSubmit: () => void
}) {
  const {data, isFetching: isFetchingNFC} = useQuery(
    ['conductorNFC', conductorDetails?.conductor_id],
    () => getConductorNFC(conductorDetails?.conductor_id!),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )

  const submitHandler = (
    values: Omit<NFCCreate, 'type'>,
    {setSubmitting: setLoading}: FormikHelpers<any>
  ) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addNFCtoConductor({
      id: values.id,
      type: 'conductor',
      nfc_code: values.nfc_code,
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err: any) => {
        handleApiError(err, toastId)
      })
      .finally(() => setLoading(false))
  }
  if (isFetchingNFC) {
    return <RunnerBall />
  }
  return (
    <div className="px-5 py-3">
      <Formik<Omit<NFCCreate & {conductor_name: string}, 'type'>>
        initialValues={{
          id: conductorDetails!.conductor_id,
          conductor_name: conductorDetails!.conductor_name,
          nfc_code: conductorDetails!.nfc_code || '',
        }}
        validationSchema={Yup.object({
          nfc_code: Yup.string()
            .trim()
            .required('RFID is required')
            .notOneOf([''], 'RFID is required'),
        })}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              label="Bus Attendee Name"
              name="conductor_name"
              disabled
            />
            <FormikControl
              control="input"
              required
              placeholder="RFID"
              label="RFID"
              name="nfc_code"
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
      {isFetchingNFC && <TopBarProgress />}
    </div>
  )
}

export default NFC
